import { render, staticRenderFns } from "./prj-detail.vue?vue&type=template&id=546343e2"
import script from "./prj-detail.vue?vue&type=script&lang=js"
export * from "./prj-detail.vue?vue&type=script&lang=js"
import style0 from "./prj-detail.vue?vue&type=style&index=0&id=546343e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports